import React, {Component} from 'react';
import {result} from 'lodash';
import PropTypes from 'prop-types';
import ColumnModel from '../../../../../../models/datasource/column';
import TableModel from '../../../../../../models/datasource/table';
import SchemaBrowserColumn from './column';
import SchemaBrowserMetaColumn from "./meta_column";
import {FEATURE_FLAGS} from "../../../../../../services/feature_flags";

export default class SchemaBrowserTable extends Component {
    columnRefs = {};

    render() {
        const {
            table,
            toggleDataTable,
            expanded,
            selectedColumn,
            hoveredColumn,
        } = this.props;

        const pkCol = table.columns.find(col => col.pk);
        return (
            <>
                <li
                    className={`w-list-unstyled table-item ${expanded ? 'open' : 'closed'}`}
                    onClick={() => toggleDataTable(!expanded)}
                >
                    {table.label}
                </li>
                {expanded && (
                    <ul>
                        {FEATURE_FLAGS.INCLUDE_META_COLUMNS &&
                            <>
                                <SchemaBrowserMetaColumn
                                    column={pkCol}
                                    label="# of"
                                />
                            </>
                        }

                        {table.columns.map(column => (
                            <SchemaBrowserColumn
                                key={column.name}
                                column={column}
                                selected={result(selectedColumn, 'id') === column.id}
                                hovered={result(hoveredColumn, 'id') === column.id}
                                ref={(el) => { this.columnRefs[column.id] = el; }}
                            />
                        ))}
                    </ul>
                )}
            </>
        );
    }
}

SchemaBrowserTable.propTypes = {
    table: PropTypes.instanceOf(TableModel).isRequired,
    expanded: PropTypes.bool,
    selectedColumn: PropTypes.instanceOf(ColumnModel),
    hoveredColumn: PropTypes.instanceOf(ColumnModel),
};

SchemaBrowserTable.defaultProps = {
    expanded: false,
};
